import React, { useEffect, useCallback } from "react";
import "./style.less";
import { useInput } from "../../../common/hooks";
import { Input, Dropdown, List } from "semantic-ui-react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  setRmBuddiesSearchQueryFilter,
  setRmBuddiesFilterBuddyBlockId
} from "../../../redux/rm-buddies/actions";
import { Link } from "react-router-dom";

function RMBuddyFilterBar() {
  const [searchInputVal, setSearchInputVal] = useInput("");
  const rmBuddiesList = useSelector(
    ({ rmBuddies }) => rmBuddies.visibleRmBuddiesList,
    shallowEqual
  );

  const currentWarehouseId = useSelector(
    ({ rmBuddies }) => rmBuddies.currentWarehouseId
  );

  const selectedRmBuddyId = useSelector(
    ({ rmBuddies }) => rmBuddies.selectedRmBuddyId
  );

  const buddyBlocksList = useSelector(
    ({ rmBuddies }) => rmBuddies.buddyBlocksList,
    shallowEqual
  );
  let options = [
    {
      key: "NULL",
      value: null,
      text: "(Search by buddy block)"
    }
  ];
  if (buddyBlocksList) {
    options = [
      ...options,
      ...buddyBlocksList.map(e => ({
        key: e._id,
        value: e._id,
        text: e.properties.name
      }))
    ];
  }
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRmBuddiesSearchQueryFilter(searchInputVal));
  }, [dispatch, searchInputVal]);
  const changeHandler = useCallback(
    (e, { value }) => {
      dispatch(setRmBuddiesFilterBuddyBlockId(value));
    },
    [dispatch]
  );
  return (
    <div className="RMBuddyFilterBar">
      <h2>
        RM
        <br />
        Buddies
      </h2>
      <br />
      <br />
      <Input
        value={searchInputVal}
        fluid
        placeholder="Search by name or number"
        inverted
        onChange={setSearchInputVal}
      />
      <br />
      <br />
      <Dropdown
        fluid
        className="inverted"
        placeholder="(Search by buddy block)"
        search
        options={options}
        selection
        onChange={changeHandler}
      />
      <br />
      <br />
      <List className="RMBuddyFilterBar-list" divided inverted relaxed>
        {rmBuddiesList &&
          rmBuddiesList.map(e => (
            <List.Item key={e._id}>
              <Link
                to={
                  currentWarehouseId
                    ? `/rmBuddies/${currentWarehouseId}/${e._id}/`
                    : ``
                }
              >
                <List.Content
                  className={selectedRmBuddyId === e._id ? "active" : ""}
                >
                  {e.name}
                  {e.task_count > 0 && (
                    <div className="filterTaskCount">{e.task_count}</div>
                  )}
                  <br />
                  {e.phone_num}
                </List.Content>
              </Link>
            </List.Item>
          ))}
      </List>
    </div>
  );
}

RMBuddyFilterBar.defaultProps = {};

RMBuddyFilterBar.propTypes = {};

export default RMBuddyFilterBar;
